import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';

const AccessDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromPath = location.state?.from;

  return (
    <DashboardLayout title="Access Denied">
      <div className="container py-5">
        <div className="text-center">
          <h2 className="mb-3">Access Denied</h2>
          <p className="text-muted mb-4">
            You do not have permission to access this page or perform this action.
          </p>
          <div className="d-flex justify-content-center gap-3">
            {fromPath && (
              <button type="button" className="btn btn-outline-secondary" onClick={() => navigate(fromPath)}>
                Go Back
              </button>
            )}
            <button type="button" className="btn btn-primary" onClick={() => navigate('/dashboard')}>
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AccessDenied;
